export default "__VITE_ASSET__9IeXikzc__"